export default __webpack_public_path__ + "5a8ae0394155f16570c42bb4f46e7858.png";